import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Partner} from '../models/partner/partner';

export abstract class PartnerForm {
  static getFormGroup(): FormGroup {
    return new FormGroup({
      accountManagerId: new FormControl(null),
      accountType: new FormControl('', Validators.required),
      status: new FormControl('active'),
      advertisingPlatform: new FormControl(''),
      prospect: new FormControl(false),
      companyStatus: new FormControl(null),
      companyName: new FormControl('', Validators.required),
      companyRegistrationNumber: new FormControl(''),
      companyVatNumber: new FormControl(''),
      langs: new FormControl([]),
      country: new FormControl(''),
      address: new FormControl(''),
      zipCode: new FormControl(''),
      state: new FormControl(''),
      city: new FormControl(''),
      email: new FormControl(''),
      phoneNumber: new FormControl(''),
      prospectOrigin: new FormControl(''),
      typology: new FormControl(''),
      verticals: new FormControl([]),
      geographicAreas: new FormControl([]),
      trafficSources: new FormControl([]),
      experience: new FormControl(),
      estimatedMonthlyRevenue: new FormControl(''),
      websiteUrl: new FormControl(),
      paymentThreshold: new FormControl(),
      paymentTerms: new FormControl(),
      paymentCurrency: new FormControl(),
      paymentMethod: new FormControl(),
      accountHolder: new FormControl(),
      bankName: new FormControl(),
      bankAddress: new FormControl(),
      iban: new FormControl(),
      swift: new FormControl(),
      routingNumber: new FormControl(),
      accountComplianceNote: new FormControl(),
      credentialUrl: new FormControl(),
      credentialUsername: new FormControl(),
      credentialPassword: new FormControl(),
      subjectToVat: new FormControl(),
    });
  }

  static update(form: FormGroup, partner: Partner): void {
    form.patchValue({
      accountManagerId: partner.accountManagerId,
      accountType: partner.accountType,
      status: partner.status,
      advertisingPlatform: partner.advertisingPlatform?.id ?? null,
      prospect: partner.prospect,
      companyStatus: partner.companyStatus,
      companyName: partner.companyName,
      companyRegistrationNumber: partner.companyRegistrationNumber,
      companyVatNumber: partner.companyVatNumber,
      langs: partner.langs,
      country: partner.country,
      address: partner.address,
      zipCode: partner.zipCode,
      state: partner.state,
      city: partner.city,
      email: partner.email,
      phoneNumber: partner.phoneNumber,
      prospectOrigin: partner.prospectOrigin,
      typology: partner.typology,
      verticals: partner.verticals,
      geographicAreas: partner.geographicAreas,
      trafficSources: partner.trafficSources,
      experience: partner.experience,
      estimatedMonthlyRevenue: partner.estimatedMonthlyRevenue,
      websiteUrl: partner.websiteUrl,
      paymentThreshold: partner.paymentThreshold ? (partner.paymentThreshold / 100) : null,
      paymentTerms: partner.paymentTerms,
      paymentCurrency: partner.paymentCurrency?.isoCode ?? 'EUR',
      paymentMethod: partner.paymentMethod,
      accountHolder: partner.accountHolder,
      bankName: partner.bankName,
      bankAddress: partner.bankAddress,
      iban: partner.iban,
      swift: partner.swift,
      routingNumber: partner.routingNumber,
      accountComplianceNote: partner.accountComplianceNote,
      credentialUrl: partner.credentialUrl,
      credentialUsername: partner.credentialUsername,
      credentialPassword: partner.credentialPassword,
      subjectToVat: partner.subjectToVat
    });
  }
}
